import React, { useCallback, useEffect, useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { ActivityInfo } from "../../../modules/lesson/activity/activity.types"
import { lllLookupService } from "../../../modules/lll/lll-lookup"
import { LllNodeBranch } from "../../../modules/lll/lll-node-branch"
import { ActivityNode } from "../../../modules/lll/lll-nodes"
import { apiClient } from "../../../infra/api-client"
import { BASE_URL } from "../../../global"
// @ts-ignore
import Loader from "react-spinner-loader"
import { Button, Container, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import urlJoin from "url-join"
import { getUserSession } from "../../../common/session/user-session"
import sha1 from "crypto-js/sha1"
import hex from "crypto-js/enc-hex"
import { accessibleService } from "../../../modules/center-services/AccessibleService";

type LllActivityContextType = {}

export const LllActivityContext = React.createContext<LllActivityContextType | null>(null)

type HeaderProp = {
    title: React.ReactElement | string | undefined;
    activity: ActivityInfo | null;
    activityTypeName: string;
}

const Header = ({ title, activity, activityTypeName }: HeaderProp) => {

    return (
        <Container className="custom-wt">
            <div className="d-flex align-items-center">
                <div className="mt-0 border-right me-4" style={{ width: "20%" }}>
                    <div
                        className="text-white font-size-14 text-uppercase cursor-pointer"
                        onClick={() => history.back()}
                    >
                        {" "}
                        <span><i className=" fas fa-chevron-left me-1"></i></span>
                        {" "}
                        Back
                    </div>
                </div>

                <div className="d-flex align-items-center justify-content-between flex-grow-1">
                    <h6 className="mb-0 font-size-20 text-white w-60 fw-regular">
                        {title}
                    </h6>
                    <p className="mb-0 text-uppercase luminous-wht">
                        {" "}
                        <span className="text-yellow me-1">
                            {activity?.subject_name}
                        </span>{" "}
                        {activityTypeName}
                        {" "}
                    </p>
          {/*<div className="luminous-wht font-size-16">*/}
          {/*  <img width={24} className="" src={awicon} alt="" />{" "}*/}
          {/*  {ActivityData && ActivityData.coins_earned*/}
          {/*    ? ActivityData.coins_earned*/}
          {/*    : 0}*/}
          {/*  /*/}
          {/*  {ActivityData &&*/}
          {/*  ActivityData.LessonActivitiesQuestions &&*/}
          {/*  ActivityData.LessonActivitiesQuestions.length > 0*/}
          {/*    ? CountTotalCoins(ActivityData.LessonActivitiesQuestions)*/}
          {/*    : 0}{" "}*/}
          {/*  coins*/}
          {/*</div>*/}
                </div>
            </div>
        </Container>

    )
}


type OnActivityEnded = (mode: 'manual' | 'auto') => void;
type LllPageProps = {}

export const LllPage = React.memo((props: LllPageProps) => {

    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const subject = searchParams.get("subject")
    const activity_key = searchParams.get("activityKey")

    const [activity, setActivity] = useState<ActivityInfo | null>(null)
    const [lllNode, setLllNode] = useState<ActivityNode>()
    const [lllNodeBranch, setLllNodeBranch] = useState<LllNodeBranch>()
    const [loading, setLoading] = useState<boolean>(false)
    const [activitySessionId, setActivitySessionId] = useState<string>()
    const [showActivityCompleted, setShowActivityCompleted] = useState<boolean>(false)
    const resultSubmitted = useRef<boolean>(false)

    const [allowed, setAllowed] = useState<boolean>(true);
    const [showBlocked, setShowBlocked] = useState<boolean>(false);

    const timeStart = useRef<number | null>(null)

    useEffect(() => {

        const { studentKey } = getUserSession()
        const _activitySessionId = sha1(studentKey + (Math.random()).toString()).toString(hex)
        setActivitySessionId(_activitySessionId);

        (async () => {

            await accessibleService.init()
            const ok = accessibleService.hasAccessToEnrichment()
            setAllowed(ok)
            setShowBlocked(!ok)
            if (!ok) return

            const activity = await fetchData()
            setActivity(activity)
            await lllLookupService.getActivityTree()
            const _lllNode = lllLookupService.findNodeByFqn(activity.activity_ref_id!)
            const _lllBranch = LllNodeBranch.createTo(_lllNode)
            setLllNode(_lllNode as ActivityNode)
            setLllNodeBranch(_lllBranch)

        })
        ()
    }, [])

    const fetchData = async () => {
        try {
            setLoading(true)
            return apiClient
                .post(BASE_URL + "studentSession/StudentAssessmentQuestions", {
                    pk_activity_key: activity_key,
                    subject_id: subject
                })
                .then(response => {
                    return response.data
                })
        } finally {
            setLoading(false)
        }
    }

    const submitSessionStarted = useCallback(async ()=> {

        const { centerKey, studentKey } = getUserSession()

        const data = {
            student_key: studentKey,
            lesson_key: activity?.fk_lesson_key,
            center_key: centerKey,
            lesson_activity_key: activity?.pk_lesson_activity_key,
            subject_id: activity?.fk_sub_id,
            session_key: activity?.fk_sest_key,
            activity_fqn: lllNode?.fqn,
            activity_session_id: activitySessionId
        }

        return apiClient
            .post(BASE_URL + "lll/saveSessionStarted", data)

    }, [activity, lllNode, activitySessionId]);

    /**
     * @param {boolean} shouldAwardCoins - Indicates whether to award coins. Award coins only when LLL auto ends.
     */
    const submitSessionResult = useCallback(async (shouldAwardCoins: boolean)=> {
        const timeEnd = Date.now()
        const duration = timeStart.current ? (Math.floor((timeEnd - timeStart.current!) / 1000)) : 0

        const { centerKey, studentKey } = getUserSession()

        const data = {
            student_key: studentKey,
            lesson_key: activity?.fk_lesson_key,
            center_key: centerKey,
            lesson_activity_key: activity?.pk_lesson_activity_key,
            subject_id: activity?.fk_sub_id,
            session_key: activity?.fk_sest_key,
            time_spent: duration,
            activity_fqn: lllNode?.fqn,
            activity_session_id: activitySessionId,
            provider_response: {},
            should_award_coins: shouldAwardCoins,
        }

        return apiClient.post(BASE_URL + "lll/submitActivityAttempt", data)
            .then(() => {

            })
    }, [activity, lllNode, activitySessionId])

    function onActivityStarted(){
        if (!allowed) return;
        timeStart.current = Date.now();
        submitSessionStarted().then();
    }

    function goBackToActivities() {
        history.back()
    }

    const onActivityEnded: OnActivityEnded = (mode) => {
        if(mode==='auto') {
            setShowActivityCompleted(true);
            if (!resultSubmitted.current) {
                resultSubmitted.current = true;
                const shouldAwardCoins = true;
                submitSessionResult(shouldAwardCoins).then();
            }
        }
        else {
            if (!resultSubmitted.current) {
                resultSubmitted.current = true;
                const shouldAwardCoins = false;
                submitSessionResult(shouldAwardCoins).then(()=>{
                    goBackToActivities();
                });
            }
            else {
                goBackToActivities();
            }
        }

    };


    return (
        <div>
            <Loader show={loading} type="body" />

            <div className="page-wrapper">
                <div className="cs-pg-header bg-dark-blue py-4">
                    <Header
                            title={lllNodeBranch?.topicDisplay}
                            activity={activity} activityTypeName={"Game"}
                    ></Header>
                </div>
            </div>

            <Modal isOpen={showBlocked} backdrop="static">
                <ModalHeader>Unavailable</ModalHeader>
                <ModalBody>Your centre is not subscribed to Enrichment (LLL) for the current period.</ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={goBackToActivities}>
                        Back
                    </Button>
                </ModalFooter>
            </Modal>

            {allowed && (
                <LllActivityContext.Provider value={{}}>
                    {lllNode && lllNodeBranch &&
                        <LllEmbeddedPage
                            lllNode={lllNode} lllNodeBranch={lllNodeBranch}
                            onActivityStarted={onActivityStarted}
                            onActivityEnded={onActivityEnded}
                        >

                        </LllEmbeddedPage>
                    }
                </LllActivityContext.Provider>
            )}

            <Modal isOpen={showActivityCompleted} size={'lg'}>
                <ModalHeader>
                    <div style={{fontSize: '150%'}}>
                        Activity Completed
                    </div>
                </ModalHeader>
                <ModalBody>
                    <div style={{fontSize: '150%'}}>
                        <div>You have completed this activity.</div>
              <div>To go back to the list of activities, click <span style={{fontStyle: 'italic'}}>"Back to Activities"</span>.</div>
              <div>To stay on to this activity, click <span style={{fontStyle: 'italic'}}>"Close"</span>.</div>
                    </div>
                </ModalBody>
                <ModalFooter>
              <Button className={'mx-2 btn-secondary'}
                onClick={()=>{setShowActivityCompleted(false)}}>
                <span style={{fontSize: '150%'}}>Close</span>
                    </Button>
            <Button className={'mx-2 btn-primary text-white'} onClick={goBackToActivities}>
              <span style={{fontSize: '150%'}}>Back to Activities</span>
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}
)

type LllEmbeddedPageProps = {
    lllNode: ActivityNode;
    lllNodeBranch: LllNodeBranch;
    onActivityEnded: OnActivityEnded;
  onActivityStarted: () => void;
}

const LllEmbeddedPage = (props: LllEmbeddedPageProps) => {

    const [lllBaseUrl, setLllBaseUrl] = useState<string>()

    async function getAuthorisationToken() {
        return Promise.resolve("eyJhbGciOiJSUzI1NiJ9.eyJpc3MiOiJodHRwczovL2xvb2tsaXN0ZW5saWZ0LmNvbSIsImF1ZCI6Imh0dHBzOi8vdHV0b3JhcGkubXlnb29yb28uaW8iLCJzdWIiOiJpbnRlZ3JhdGlvbi10ZXN0LXVzZXItTExMIiwiaWF0IjoxNzQ3ODU0ODEwLCJleHAiOjE3NzY4MTYwMDB9.uGnoBi6EO59gJ_H4HkXulYabhFwPDFZZ0nFRh3tN9owgY8wzqDYXRU_nN-ToQRTlmFRTTaI79gw4H1ff8bMtWe4EHqtEXSFbkQv5zPD2-DHBN7vdTszOCJs0RDFfkoEg6bIwgA9OkQ9HBdaXegfbRvfC69dnLkPZhWHVzigydxnBJfrSOloR2ouG44i0nY7XvtHXZo7kCMChrQxZjZ2VbhMYB6U_d9hGfi-3j4rLovoKxGDbIV9AtR87DhfvW-B1IKJ8OUWWtVlcKVXIZ08WsWh3rISrI5g_zFXg7gYu_XYMj47_EE8gmXdxuaAcHcUYboLsDmY6WzpskFnxErZxCw")
    }

    const [activityUrl, setActivityUrl] = useState<string>()

    useEffect(() => {
        async function init() {
            const baseUrl = lllLookupService.getBaseUrl()
            const token = await getAuthorisationToken()
            const _activityUrl = urlJoin(baseUrl, props.lllNode.relativeLink + `?token=${token}`)

            setActivityUrl(_activityUrl)
            setLllBaseUrl(baseUrl)
        }
        init().then()
    }, [props.lllNode.relativeLink])

    const handleMessage = useCallback((event: MessageEvent) => {

            if (event.data.type === "REQUEST_ORIGIN") {
                const iframe = document.getElementById("activityFrame") as HTMLIFrameElement
                iframe!.contentWindow!.postMessage({
                        type: "REPLY_ORIGIN",
                        payload: {
                            origin: window.location.origin
                        }
                    },
                    lllBaseUrl!
                )
            }

            if(event.data.type === "ACTIVITY_STARTED") {
                const payload = event.data.payload;
                const timestamp = new Date(payload.timestamp)
                props.onActivityStarted();
            }

            if(event.data.type === "ACTIVITY_ENDED") {
      const payload = event.data.payload;
      const timestamp = new Date(payload.timestamp)
      props.onActivityEnded('auto');
            }

    if(event.data.type === "ACTIVITY_QUIT") {
      const payload = event.data.payload;
      const timestamp = new Date(payload.timestamp)
    }

  }, [lllBaseUrl, props.onActivityStarted, props.onActivityEnded])

    useEffect(() => {
      window.addEventListener("message", handleMessage)

    return ()=>{
        window.removeEventListener("message", handleMessage)
    }
  }, [handleMessage])


    return (
        <div>

      <div className="m-2 p-2" style={{ fontSize: "1.5em", border: "2px red solid" }}>
        Centre Optional Add on - Free Trial for one month
      </div>

            <div className={"mb-2"} style={{ width: "80%", margin: "auto" }}>
        <Button color="danger" style={{ width: "100%", fontWeight: "bolder", fontSize: "120%" }}
                onClick={ ()=>props.onActivityEnded('manual')}>
                    End Activity
                </Button>
            </div>

      {!activityUrl &&
                <div style={{ marginTop: "10em" }}>
                    <Loader show={!activityUrl} type="inline" spinnerSize="200px" />
                </div>
      }

      {activityUrl &&
                <div className="d-flex w-100 p-3 pt-0">
          <iframe id="activityFrame" src={activityUrl}
                  style={{ width: "100%", minHeight: "80vh" }}
          ></iframe>
                </div>
      }

        </div>
  )

}